import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 动态路由配置：path 片段 -> section（业务区块）
const ROUTE_SECTIONS = [
  { path: 'shortNovel', section: 'short-novel' },
  { path: 'longNovel', section: 'long-novel' },
  { path: 'coreIdea', section: 'coreIdea' },
  { path: 'outline', section: 'outline' },
  { path: 'cover', section: 'cover' },
  { path: 'vipRecharge', section: 'vip-recharge' },
  { path: 'profile', section: 'profile' },
  { path: 'myNovels', section: 'my-novels' },
  { path: 'consumeRecord', section: 'consume-record' }
]

const PATH_TO_SECTION = {}
const SECTION_TO_PATH = {}
ROUTE_SECTIONS.forEach(function (item) {
  PATH_TO_SECTION[item.path] = item.section
  SECTION_TO_PATH[item.section] = '/' + item.path
})

const DEFAULT_PATH = '/shortNovel'

export { PATH_TO_SECTION, SECTION_TO_PATH, DEFAULT_PATH }

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: DEFAULT_PATH
    },
    {
      path: '/:section',
      name: 'section',
      meta: { dynamic: true },
      beforeEnter (to, from, next) {
        const segment = to.params.section
        if (PATH_TO_SECTION[segment]) {
          next()
        } else {
          next(DEFAULT_PATH)
        }
      }
    }
  ]
})

router.afterEach(function (to, from) {
  // Vue Router history 模式：无整页刷新，路由切换需手动上报 PV；路径与地址栏一致（无 hash）
  setTimeout(function () {
    try {
      if (!window._hmt || typeof window._hmt.push !== 'function') return
      var path =
        (typeof window.location !== 'undefined' && window.location.pathname
          ? window.location.pathname + (window.location.search || '')
          : '') || (to && to.fullPath) || '/'
      window._hmt.push(['_trackPageview', path])
    } catch (e) {}
  }, 0)
})

export default router